// import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@fixit/utils';

export default class Salon {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};
        this.address = args.address || ''
        this.imgUrl = args.imageLocation || ''
        this.name = args.name || ''
        this.distance = args.distance || null
        this.mapLatitude = args.mapLatitude || ''
        this.mapLongitude = args.mapLongitude || ''
        this.urlFrendlyLink = args.urlFrendlyLink || ''
        this.chainId = args.chainId || null
        this.siteId = args.siteId || null
        this.availableCategories = args.availableCategories || []
        this.availableTreatments = args.availableTreatments || []
        this.averageRating = args.averageRating
        this.postalArea = args.postalArea || ''
        this.postalCode = args.postalCode || ''
	}

	assign(salon) {
		Object.assign(this, toCamelCaseProperties(salon));
	}
}
